import { render } from "./Office.vue?vue&type=template&id=5259fa35&scoped=true"
import script from "./Office.vue?vue&type=script&lang=js"
export * from "./Office.vue?vue&type=script&lang=js"

import "./Office.vue?vue&type=style&index=0&id=5259fa35&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5259fa35"

export default script